import type { ComponentProps } from 'react';
import type { CollectionsRail } from '@sg/garnish';
import { slugify } from '@sg/garnish';

import type { MenuCollectionsQuery } from './GraphQL';

// ────────────────────────────────────────────────────────────────────────────────

export function formatMenuCollections(
  menuCollections: MenuCollections,
  excludedCollectionId = '',
): CollectionRailItems {
  const menuCollectionsList = menuCollections ?? [];

  return menuCollectionsList
    .filter(excludeMenuCollection(excludedCollectionId))
    .map(serializeMenuCollections);
}

// ────────────────────────────────────────────────────────────────────────────────

function serializeMenuCollections(menuCollection: MenuCollection) {
  const { id, primaryImageUrl, primaryTitle, primaryDescription } =
    menuCollection;
  const testID = `${slugify(primaryTitle)}-collection-card`;

  return {
    id,
    imageUrl: primaryImageUrl,
    title: primaryTitle,
    description: primaryDescription,
    testID,
  };
}

function excludeMenuCollection(excludedCollectionId: string) {
  return function ({ id }: Pick<MenuCollection, 'id'>) {
    return encodeCollectionId(id) !== encodeCollectionId(excludedCollectionId);
  };
}

function encodeCollectionId(collectionId: string) {
  if (!collectionId.includes(':')) return collectionId;

  return encodeURIComponent(collectionId);
}

// ─── TYPES ──────────────────────────────────────────────────────────────────────

type MenuCollection = MenuCollections[number];

type MenuCollections = MenuCollectionsQuery['menuCollections'];

type CollectionRailItems = ComponentProps<
  typeof CollectionsRail
>['collections'];
